module.exports = __webpack_public_path__ + "static/img/s507.c91ebd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s507.png
// module id = 569
// module chunks = 3